import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa6";
import { FiMail, FiMapPin, FiPhone } from "react-icons/fi";
import contactInfo from "../../data/contactInfo";
import { footerQuickLinks, footerServices } from "../../data/navigation";
import { toRoutePath } from "../../lib/seo";
import SocialSection, { socialLinks } from "../SocialSection";
import styles from "./Footer.module.css";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <div>
      <section className={styles.ctaBanner}>
        <div className={styles.ctaShell}>
          <div className={styles.ctaText}>
            <span className={styles.ctaKicker}>
              Ready to strengthen your practice?
            </span>

            <h2 className={styles.ctaHeading}>
              Let&apos;s Build the Right Solution Together
            </h2>

            <p className={styles.ctaParagraph}>
              Tell us about your goals and we&apos;ll help you identify the best
              next step.
            </p>
          </div>

          <Link to={toRoutePath("/contact-us")} className={styles.ctaButton}>
            Connect With an Expert
            <FaArrowRight aria-hidden="true" />
          </Link>
        </div>
      </section>

      <footer className={styles.footer}>
        <div className={styles.shell}>
          <div className={styles.topRow}>
            <section className={`${styles.column} ${styles.brandColumn}`}>
              <Link
                to="/"
                className={styles.footerBrand}
                aria-label="MIT4Doctors home"
              >
                <img
                  src="/img/logo/mit-logo-w.webp"
                  alt="MIT4Doctors"
                  className={styles.logo}
                />
              </Link>

              <p className={styles.description}>
                MITSI revolutionizes healthcare with advanced medical technology
                and services. They enhance patient care, improve efficiency, and
                offer reliable support to healthcare providers.
              </p>

              <SocialSection links={socialLinks} variant="dark" />
            </section>

            <section className={`${styles.column} ${styles.linksColumn}`}>
              <h3>Company</h3>

              <nav className={styles.linkList} aria-label="Company links">
                {footerQuickLinks.map((item) => (
                  <Link key={item.to} to={toRoutePath(item.to)}>
                    {item.label}
                  </Link>
                ))}
              </nav>
            </section>

            <section className={`${styles.column} ${styles.linksColumn}`}>
              <h3>Featured Services</h3>

              <nav
                className={styles.linkList}
                aria-label="Featured service links"
              >
                {footerServices.slice(0, 5).map((item) => (
                  <Link key={item.to} to={toRoutePath(item.to)}>
                    {item.label}
                  </Link>
                ))}
              </nav>
            </section>

            <section className={`${styles.column} ${styles.connectColumn}`}>
              <h3>Connect</h3>

              <div className={styles.contactList}>
                <div className={styles.contactItem}>
                  <span className={styles.contactIcon} aria-hidden="true">
                    <FiPhone />
                  </span>

                  <a href={contactInfo.phoneHref}>{contactInfo.phone}</a>
                </div>

                <div className={styles.contactItem}>
                  <span className={styles.contactIcon} aria-hidden="true">
                    <FiMail />
                  </span>

                  <a href={contactInfo.emailHref}>{contactInfo.email}</a>
                </div>

                <div className={styles.contactItem}>
                  <span className={styles.contactIcon} aria-hidden="true">
                    <FiMapPin />
                  </span>

                  <a
                    href={contactInfo.address.mapHref}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {contactInfo.address.line1}
                    <br />
                    {contactInfo.address.line2}
                  </a>
                </div>
              </div>
            </section>
          </div>

          <div className={styles.bottomRow}>
            <p className={styles.copyright}>
              &copy; {currentYear}{" "}
              <Link to="/" className={styles.copyrightLink}>
                MIT4Doctors
              </Link>
              . All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
